<template>
  <div id="Attachment">
    <Head />
    <div class="attachment">
      <div class="leftNav">
        <decLeftNav ref="LeftNav" />
      </div>
      <main>
        <div class="top">
          <div class="title">
            <img src="../../assets/Declare/WORD.png" />
            附件
            <el-upload
              class="upload-demo"
              :before-upload="befoup"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-progress="progress"
              :on-error="error"
              :on-success="befoup"
              :limit="1"
              multiple
              :data="{'upload_type': 'files','token':token,'ReportID':ReportID}"
              :headers="{'enctype':'multipart/form-data'}"
              :on-exceed="handleExceed"
              :file-list="fileList"
              accept=".doc, .docx"
            >
              <template>
                <div class="anniu">
                  <el-button size="small" style=" margin-right:.3rem " type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">请务必将原始申报表、主报告、鉴定证书及其他支撑材料，整合为一个word文档上传。</div>
                  <!-- <div slot="tip" class="el-upload__tip">请上传原版主报告和相关证明材料，上传文件后缀名必须为docx，doc，大小不超过20M</div> -->
                </div>
              </template>
            </el-upload>
            <!-- <div class="btn">
              <div>点击上传</div>
             
              <input type="file" accept=".docx, .doc" @change="getfileList($event)" />
              <p class="show"></p>
            </div>-->
            <!-- <span>上传的文件后缀名必须为docx、doc，大小不超过5M</span> -->
          </div>
          <div class="file">
            <!-- <div class="List" v-if="word">{{word}}</div> -->
            <div class="List" v-if="word">
              <p>附件:{{fj}}</p>
              <div :style="'width:' + width"></div>
            </div>
            <div class="default" v-else>暂无附件</div>
          </div>
        </div>
        <!-- <div class="ylW"  v-show="ylW" >
          <iframe frameborder="0" width="100%" height="90%" name="hrong" class="iframe"></iframe>
        </div>-->
        <div class="submit" @click="save()">保存</div>
        <!-- <div class="submit" @click="setInfo()">提交成果申请</div> -->
      </main>
    </div>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "@/components/Head";
import Foot from "@/components/Foot";
import decLeftNav from "@/components/decLeftNav";
import RightNav from "../../components/RightNav";
export default {
  name: "Chart",
  data() {
    return {
      ReportID: "",
      // word: "",
      word: [],
      width: "0%",
      // ylW: false,
      fj: "",
      msg: "",
      fileList: [],
      token: sessionStorage.getItem("token"),
      name: "",
      con: "",
      sum: 0,
      // File:''
    };
  },

  components: {
    Head,
    Foot,
    decLeftNav,
    RightNav,
  },
  created() {
    window.scrollTo(0, sessionStorage.getItem("scroll"));
  },
  mounted() {
    console.log(this.token);
    console.log(sessionStorage.getItem("name"), 55);
    if (!sessionStorage.getItem("name")) {
      this.$router.replace("/Declare");
    }
    // this.$refs.LeftNav.isTable();
    if (sessionStorage.getItem("isListGo") == "true") {
      this.ReportID = sessionStorage.getItem("reportID");
      console.log(sessionStorage.getItem("reportID"));
    } else {
      this.ReportID = sessionStorage.getItem("ReportID");
      console.log(sessionStorage.getItem("ReportID"));
    }
    if (this.$route.query.ReportID) {
      this.ReportID = this.$route.query.ReportID;
    }
    this.getFj("fj1");
    // this.getValur();
    // if(sessionStorage.getItem("isTable")=="false"){
    //   this.$router.replace("/Declare");
    // }
  },
  methods: {
    //取得已经上传的文件
    getFj(title) {
      // var con = "";
      if (this.sum > 2) {
        return;
      }
      this.$axios
        .post(
          "reportcontent/getcontent",
          this.$qs.stringify({
            ReportID: this.ReportID,
            token: this.token,
            Title: title,
          })
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 10000) {
            // con = res.data.data;
            // if (res.data.data) {
            //   if (this.fileList.length > 0) this.fileList.push();
            // }
            this.sum = this.sum + 1;
            if (title == "fj1") {
              if (res.data.data) {
                this.fileList.push({ name: "", url: "" });
                this.fileList[0].url = res.data.data;
              }
            } else {
              this.fileList[0].name =
                res.data.data || this.fileList[0].url.split("/")[6];
            }
            this.getFj("fj1_name");
          }
        });
    },

    befoup(file) {
      let fd = new FormData();
      console.log(file);
      fd.append("file", file);
      fd.append("upload_type", "files");
      // fd.append("version_id", this.version_id);
      // var axios = this.$axios.create({
      //   baseURL: "",
      // });
      this.$axios.post("upload/index", fd).then(
        // this.$axios.post("upload/index", fd).then(
        (res) => {
          // this.importDataBtnText = "导入成功";
          if (res.data.code == 10000) {
            this.$message({ message: res.data.msg, type: "success" });
            this.fileList.push({ name: "", url: "" });
            this.fileList[0].name = file.name;
            this.fileList[0].url = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        },
        (res) => {
          // this.importDataBtnText = "导入失败";
          console.log(res);
        }
      );
      return false;
    },
    error(err, file, fileList) {
      console.log(fileList);
      console.log(err);
      if (err) {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
      }
      console.log(file);
    },
    progress(event, file, fileList) {
      console.log(event);

      console.log(file);
      console.log(fileList);
    },
    handleRemove(file, fileList) {
      console.log(this.fileList);
      this.fileList = "";
      console.log(this.fileList);
      this.fileList = fileList;
      console.log(this.fileList);
      console.log(file, fileList, 66666);
    },
    handlePreview() {},
    handleExceed() {
      this.$message.warning("当前限制最多上传 1 个文件");
    },
    beforeRemove(file, fileList) {
      console.log(fileList);
      let a = true;
      if (file && file.status === "success") {
        a = this.$confirm(`确定移除 ${file.name}？`);
      }
      return a;
    },
    // getValur() {
    //   let that = this;
    //   console.log(that.ReportID, 11111);
    //   that.$axios
    //     .post(
    //       that.$URL +
    //         "/reportcontent/info?ReportID=" +
    //         (that.$route.query.ReportID || that.ReportID) +
    //         "&token=" +
    //         sessionStorage.getItem("token")
    //     )
    //     .then(function (res) {
    //       if (res.data.code == 10000) {
    //         that.msg = res.data.data;
    //         console.log(res, 111);
    //         that.msg.forEach((element) => {
    //           if (element.Title == "fj1") {
    //             console.log(element.Content);
    //             // that.word=element.Content.split("/")[6];
    //             // console.log(that.File,'fileN11')
    //             // that.ylW=true
    //             // that.fj1=true
    //           }
    //         });
    //       } else if (res.data.code == 10002) {
    //         this.$message({
    //           type: "warning",
    //           message: res.data.msg,
    //         });
    //       } else {
    //         this.$message.error(res.data.msg);
    //       }
    //     })
    //     .catch(function () {});
    // },
    // getfileList(e) {
    //   let that = this;
    //   let file = e.target.files[0];
    //   console.log(file, "fff");
    //   this.fj = file.name;
    //   if (!file) {
    //     return;
    //   }
    //   let fileForm = new FormData();
    //   fileForm.append("file", file);
    //   fileForm.append("upload_type", "files");
    //   console.log(fileForm);
    //   that.$axios
    //     .post(
    //       "upload/index?token=" +
    //         sessionStorage.getItem("token") +
    //         "&ReportID=" +
    //         this.ReportID,
    //       fileForm,
    //       {
    //         headers: {
    //           "Content-type": "multipart/form-data",
    //         },
    //         onUploadProgress(e) {
    //           //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
    //           //如果lengthComputable为false，就获取不到e.total和e.loaded
    //           if (e.lengthComputable) {
    //             var rate = (that.uploadRate = e.loaded / e.total); //已上传的比例
    //             if (rate < 1) {
    //               that.width = (rate * 100).toFixed(2) + "%";
    //             }
    //           }
    //         },
    //       }
    //     )
    //     .then(function (res) {
    //       if (res.data.code == 10000) {
    //         that.width = "100%";
    //         console.log(res, "res");
    //         that.$message({ message: "上传成功", type: "success" });
    //         that.width = "0%";
    //         that.addLattice("fj1", res.data.data);
    //         // that.word="附件1"
    //         // that.word = file.name;
    //         that.word.push(file.name);
    //         // that.ylW = true;
    //         // that.fj1 =true ;
    //         // window.frames["hrong"].location.href ="http://view.xdocin.com/xdoc?_xdoc=" + res.data.data;
    //       } else if (res.data.code == 10002) {
    //         this.$message({
    //           type: "warning",
    //           message: res.data.msg,
    //         });
    //       } else {
    //         that.width = "0%";
    //         that.$message.error(res.data.msg);
    //       }
    //       // else {
    //       //   that.width = "0%";
    //       //   that.$message.error(res.data.msg, "bc");
    //       // }
    //     })
    //     .catch(function (err) {
    //       console.log(err);
    //     });
    // },
    addLattice(Title, Content) {
      let that = this;
      that.$axios
        .post(
          "/reportcontent/save",
          that.$qs.stringify({
            Title: Title,
            Content: Content,
            ReportID: this.ReportID,
            token: sessionStorage.getItem("token"),
          })
        )
        .then((res) => {
          if (res.data.code != 10000) {
            this.$message.error(res.data.msg);
          }
        });
    },
    save() {
      this.addLattice(
        "fj1_name",
        this.fileList.length > 0 ? this.fileList[0].name : ""
      );
      this.addLattice(
        "fj1",
        this.fileList.length > 0 ? this.fileList[0].url : ""
      );
      this.$router.push("/tableList?top=0");
    },
    // setInfo() {
    //   var that = this;
    //   console.log(that.word,'word')
    //   if (that.word) {
    //     this.$confirm("确认提交申请报告吗?", "提示", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning"
    //     })
    //       .then(() => {
    //         that.$axios
    //           .post(
    //             that.$URL +"/report/reportover?ReportID=" +that.ReportID +"&token=" +sessionStorage.getItem("token")
    //           )
    //           .then(res => {
    //             if (res.data.code == 10000) {
    //               that.$message({
    //                 message: res.data.msg,
    //                 type: "success"
    //               });
    //               that.$router.push('/tableList')
    //             } else {
    //               that.$message.error(res.data.msg);
    //               console.log(res,'err')
    //             }
    //           });
    //       })
    //       .catch(() => {
    //         this.$message({
    //           type: "info",
    //           message: "已取消修改"
    //         });
    //       });
    //   }
    // }
  },
  // watch: {
  //   fileList: function () {
  //     this.getFj("fj1_name");
  //   },
  // },
};
</script>
<style lang="less">
#Attachment {
  .el-upload-list {
    position: absolute;
    top: 7%;
    left: 6%;
    z-index: 10;
  }
}
</style>
<style lang="less" scoped>
#Attachment {
  width: 100%;
  min-width: 1000px;
  .attachment {
    width: 100%;
    padding: 0 1.35rem;
    display: flex;
    align-items: stretch;
    margin-top: 0.4rem;
    font-size: 0.18rem;
    .leftNav {
      padding-right: 0.4rem;
      border-right: 0.01rem solid #e4e4e4;
    }
    main {
      width: 100%;
      margin-left: 0.25rem;
      position: relative;
      .top {
        .title {
          display: flex;
          align-items: center;
          font-size: 0.24rem;
          .anniu {
            display: flex;
            margin-left: 0.4rem;
          }
          img {
            width: 0.32rem;
            height: 0.32rem;
            margin-right: 0.2rem;
          }
          .btn {
            position: relative;
            cursor: pointer;
            div {
              width: 1rem;
              height: 0.3rem;
              line-height: 0.3rem;
              background: #2d65d2;
              color: #fff;
              font-size: 0.16rem;
              text-align: center;
              border-radius: 0.04rem;
              margin-left: 0.3rem;
              position: absolute;
              top: 0.05rem;
            }
            input {
              position: relative;
              left: 0.2rem;
              opacity: 0;
            }
          }
          span {
            color: #aaa;
            font-size: 0.2rem;
            position: absolute;
            left: 2.7rem;
          }
        }
        .file {
          margin-top: 0.45rem;
          .List {
            width: 80%;
            display: flex;
            align-items: center;
            position: relative;
            div {
              position: absolute;
              left: 0;
              bottom: -0.1rem;
              background: #57a6f7;
              height: 0.05rem;
            }
            // li {
            //   position: relative;
            //   display: initial;
            //   > div {
            //     position: absolute;
            //     left: 0;
            //     bottom: -0.02rem;
            //     background: #57a6f7;
            //     height: 0.02rem;
            //   }
            // }
          }
          .default {
            color: #afafaf;
          }
        }
      }
      // .ylW {
      //   width: 100%;
      //   height: 11rem;
      //   background: rgba(0, 0, 0, 0.6);
      //   margin: 0.3rem 0 1rem;
      //   position: relative;
      //   .iframe {
      //     width: 90%;
      //     margin: 0.5rem 0 0.3rem 0.6rem;
      //   }
      //   img {
      //     width: 0.3rem;
      //     height: 0.3rem;
      //     position: absolute;
      //     right: 0.25rem;
      //     top: 0.25rem;
      //   }
      // }
      .submit {
        width: 4.75rem;
        height: 0.7rem;
        line-height: 0.7rem;
        text-align: center;
        font-size: 0.3rem;
        color: #fff;
        background: #2d65d2;
        // margin: 0 auto;
        border-radius: 0.08rem;
        cursor: pointer;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: 50%;
      }
    }
  }
}
</style>